import {dynamic} from '@github-ui/dynamic'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {withLazyAppBoundary} from '@github-ui/react-core/lazy-app-boundary'

import {buildPulseRoute} from './pulse-route'

export function createPulseRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  const route = buildPulseRoute(appBuilder)
  const LazyPulse = dynamic(
    async () => {
      const module = await import('./Pulse')
      return {default: module.Pulse}
    },
    {ssr: false},
  )
  const PulseRoute = Object.assign(() => <LazyPulse route={route} />, {
    preload: LazyPulse.preload,
    ssr: LazyPulse.ssr,
  })

  return route.toRoute({Component: withLazyAppBoundary(PulseRoute)})
}
